import React, { useContext, useEffect, useState } from 'react';
import './ParentAccount.css';
import { useNavigate, useParams } from 'react-router-dom';
import { PassengerAPI } from '../../../../API/PassengerAPIs/PassengerAPIs';
// import { FaChevronUp, FaChevronDown } from 'react-icons/fa';
import NotificationContext from '../../../../STCLibrary/NotificationSystem/NotificationContext';
import ApiResponseHandler from '../../../../STCLibrary/ApiResponseHandler/ApiResponseHandler';

export default function ParentAccount() {
    const routeParams = useParams();
    const navigate = useNavigate();
    const notificationCtx = useContext(NotificationContext);

    const [loading, setLoading] = useState(true);
    const [accountData, setAccountData] = useState();
    const [isOpen, setIsOpen] = useState(true);

    const getAccountData = () => {
        PassengerAPI.GetPortalAccount(routeParams.userID)
            .then((response) => {
                if (response.status === 200) {
                    setAccountData(response.data);
                    setLoading(false);
                }
            })
            .catch((err) => {
                console.log(err);
                ApiResponseHandler(err.response, notificationCtx, navigate);
            });
    };

    const postChangeEmail = () => {

        //This functionallity has no check in the backend to see if the new email address being used is already linked to an existing account. 
        //Need to add in this check for leader accounts and passenger accounts existing before using the change email API 

        const newEmail = "david@schooltour.ie"

        
        PassengerAPI.PostChangeEmail(accountData.payerId, newEmail)
            .then((response) => {
                if (response.status === 200) {
                    console.log(response.data);
                    setLoading(false);
                }
            })
            .catch((err) => {
                console.log(err);
                ApiResponseHandler(err.response, notificationCtx, navigate);
            });
    };

    const postAccountDetails = () => {

        const postJSON = {
            ...accountData
        }
        postJSON.phone = '12345';
        delete postJSON.signupAskedPassport;
        delete postJSON.id;
        delete postJSON.isNewAccount;
        console.log('Posting: ', postJSON)
        PassengerAPI.PostPortalAccount(postJSON)
            .then((response) => {
                if (response.status === 200) {
                    console.log(response.data);
                    
                }
            })
            .catch((err) => {
                console.log(err);
                // ApiResponseHandler(err.response, notificationCtx, navigate);
            });
    };

    useEffect(() => {
        getAccountData();
    }, []);

    // const toggleDropdown = () => {
    //     setIsOpen(!isOpen);
    // };

    // const handleChevronClick = (e) => {
    //     e.stopPropagation();
    //     toggleDropdown();
    // };

    if (loading) {
        return <div>Loading account details...</div>;
    }

    return (
        <div className="parent-account-container">
            <div className="dropdown-button">
                <div>
                    <strong>Parent Account</strong>
                </div>
                {/* <div className="chevron-icon" onClick={handleChevronClick}>
                    {isOpen ? <FaChevronUp /> : <FaChevronDown />}
                </div> */}
            </div>

            {/* <div><button onClick={() => postChangeEmail()}>Test Email</button></div>
            <div><button onClick={() => postAccountDetails()}>Test Account</button></div> */}
            {isOpen && (
                <div className="dropdown-content">
                    <div className="account-details-box">
                        <div className="account-details-label">Email: {accountData.email}</div>
                    </div>
                    <div className="account-details-box">
                        <div className="account-details-label">Phone Number: {accountData.phone}</div>
                    </div>
                    <div className="account-details-box">
                        <div className="account-details-label">
                            Verified: <input type="checkbox" checked={accountData.verified} readOnly />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
